import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    meta: {
        pageNumber: 1,
        pageSize: 20,
        itemTotal: 0
    },
    list: [],
    selectedAnnouncement: {
        _id: undefined,
    },
    announcementAdded: false,
    announcementUpdated: false,
    announcementRemoved: false,
};

const announcementSlice = createSlice({
    name: 'announcements',
    initialState,
    reducers: {
        getAnnouncements(state, action) {
            state.list = action.payload.announcements;
            state.meta = action.payload.meta
        },
        viewAnnouncement(state, action) {
            state.selectedAnnouncement = action.payload;
        },
        addAnnouncement(state, action) {
            state.announcementAdded = true
        },
        updateAnnouncement(state, action) {
            state.announcementUpdated = true
        },
        removeAnnouncement(state, action) {
            state.announcementRemoved = true
        },
        reset: (state) => initialState,
        logout: (state) => initialState,
    },
});

export const announcementActions = announcementSlice.actions;
export default announcementSlice;
